import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IColorConfiguration, IColorProps, IColorState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { COLOR_CATEGORY_KEY, COLOR_COMPONENT_KEY } from './Color.meta.js';

export class Color extends ComponentBase<IColorProps, IColorState, IColorConfiguration> {
	categoryKey = COLOR_CATEGORY_KEY;
	componentKey = COLOR_COMPONENT_KEY;

	constructor(props: IColorProps) {
		super(props);
	}

	get color(): string {
		const { aliases = [], color: value } = this.props;
		const alias = aliases.find((a) => a.value === value);
		if (alias && alias.color) {
			return alias.color;
		}
		if (typeof value === 'string') {
			return value;
		}
		if (!common.commonUtils.isNullOrUndefined(value)) {
			return value.toString();
		}
		return '#ffffff';
	}

	render() {
		const { className } = this.props;
		const color = this.color;
		return (
			<Wrapper className={className} style={{ backgroundColor: color }}>
				&nbsp;
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(Color), COLOR_CATEGORY_KEY, COLOR_COMPONENT_KEY);
